module.exports = __webpack_public_path__ + "img/product_icon4.8f102618.png";